import { View } from 'backbone.marionette';
import { User } from '../../../../models';
import popup_teamplate from './popup_teamplate.jst';
import Modal from '../../../../utils/Modal';

/**
 * @desc League CoreLeagueLadderView Row View Class
 */
export class CoreLadderTeamRow extends View {
	ui() {
		return {
			'view_team': '.js-view-team'
		};
	}

	events() {
		return {
			'click @ui.view_team': 'viewTeam'
		}
	}

	regions() {
		return {
			'view_team': '.view-team'
		}
	}

	get className() {
		return 'table-row-item ladder-row';
	}

	initialize() {
		this.league = this.getOption('league');
		this.updateModel();
	}

	updateModel() {
		this.model
			.set({
				league_start_round: this.league.get('start_round'),
				current_user_id: User.get('id'),
				current_round: this.league.get('current_round'),
				selected_round: this.league.get('selected_round'),
				status: this.league.get('status'),
				fixtures: this.league.get('fixtures'),
				finals_format: this.league.get('finals_format'),
				bye_rounds: this.league.get('bye_rounds'),
				league: this.league
			})
			.setAvatar()
			.updateLadderData();

		this.render();
	}

	viewTeam() {
		this.alertViewTeam();
	}

	alertViewTeam() {
		Modal.create({
			template: popup_teamplate(),
			events: {
				'click .js-close': 'close'
			}
		});
	}
}

export default CoreLadderTeamRow;